import * as a11y from '@shopify/theme-a11y';
import * as Layout from '../utilities/layout';
Avatar.theme = Avatar.theme || {};

Avatar.theme.Modals = function ModalFn() {
  var classes = {
    drawerTranslate: 'tw-translate-x-full',
    hide: 'tw-hidden'
  };

  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: ".js-modal-open-".concat(name),
      openClass: 'modal--is-active',
      closeModalOnClick: false,
      drawer: false
    };

    if (options.container) {
      this.modal = options.container.querySelector("#".concat(id));
    } else {
      this.modal = document.getElementById(id);
    }

    if (!this.modal) return false;
    this.nodes = {
      parents: [document.querySelector('html'), document.body]
    };
    this.config = Object.assign(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal;

    if (options.container) {
      this.openElement = options.container.querySelector(this.config.open);
    } else {
      this.openElement = document.querySelector(this.config.open);
    }

    this.init();
  }

  Modal.prototype.init = function () {
    if (this.config.drawer) {
      this.openElement.addEventListener('click', this.openDrawer.bind(this));
      this.modal.querySelector(this.config.close).addEventListener('click', this.closeDrawer.bind(this));
    } else {
      this.openElement.addEventListener('click', this.open.bind(this));
      this.modal.querySelector(this.config.close).addEventListener('click', this.closeModal.bind(this));
    }
  };

  Modal.prototype.open = function (evt) {
    var self = this;
    Layout.fadeInOverlay();
    Layout.scrollLock(); // Keep track if modal was opened from a click, or called by another function

    var externalCall = false;
    if (this.modalIsOpen) return; // Prevent following href if link is clicked

    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    } // Without this, the modal opens, the click event bubbles up
    // which closes the modal.


    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    if (this.modalIsOpen && !externalCall) {
      this.closeModal();
    }

    this.modal.classList.add(this.config.openClass);
    this.nodes.parents.forEach(function (node) {
      node.classList.add(self.config.openClass);
    });
    this.modalIsOpen = true;
    a11y.trapFocus(this.modal, {
      elementToFocus: this.focusOnOpen
    });
    this.bindEvents();
  };

  Modal.prototype.openDrawer = function (evt) {
    var _this = this;

    var self = this; // Layout.fadeInOverlay();
    // Layout.scrollLock();
    // Keep track if modal was opened from a click, or called by another function

    var externalCall = false;
    if (this.modalIsOpen) return; // Prevent following href if link is clicked

    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    } // Without this, the modal opens, the click event bubbles up
    // which closes the modal.


    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    if (this.modalIsOpen && !externalCall) {
      this.closeDrawer();
    }

    this.modal.classList.remove(classes.hide);
    setTimeout(function () {
      _this.modal.classList.remove(classes.drawerTranslate);
    }, 0);
    this.modal.addEventListener('transitionend', function () {
      a11y.trapFocus(_this.modal);
    }, {
      once: true
    });
    this.nodes.parents.forEach(function (node) {
      node.classList.remove(classes.hide);
    });
    this.modalIsOpen = true;
    this.bindEvents();
  };

  Modal.prototype.closeModal = function () {
    if (!this.modalIsOpen) return;
    Layout.fadeOutOverlay();
    Layout.scrollUnlock();
    document.activeElement.blur();
    this.modal.classList.remove(this.config.openClass);
    var self = this;
    this.nodes.parents.forEach(function (node) {
      node.classList.remove(self.config.openClass);
    });
    this.modalIsOpen = false;
    a11y.removeTrapFocus({
      container: this.modal
    });
    this.openElement.focus();
    this.unbindEvents();
  };

  Modal.prototype.closeDrawer = function () {
    var _this2 = this;

    if (!this.modalIsOpen) return; // Layout.fadeOutOverlay();
    // Layout.scrollUnlock();

    document.activeElement.blur();
    this.modal.classList.add(classes.drawerTranslate);
    this.modal.addEventListener('transitionend', function () {
      _this2.modal.classList.add(classes.hide);
    }, {
      once: true
    });
    var self = this;
    this.nodes.parents.forEach(function (node) {
      node.classList.remove(self.config.openClass);
    });
    this.modalIsOpen = false;
    a11y.removeTrapFocus();
    this.openElement.focus();
    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    this.keyupHandler = this.keyupHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    document.body.addEventListener('keyup', this.keyupHandler);
    document.body.addEventListener('click', this.clickHandler);
  };

  Modal.prototype.unbindEvents = function () {
    document.body.removeEventListener('keyup', this.keyupHandler);
    document.body.removeEventListener('click', this.clickHandler);
  };

  Modal.prototype.keyupHandler = function (event) {
    if (event.keyCode === 27) {
      if (this.config.drawer) {
        this.closeDrawer();
      } else {
        this.closeModal();
      }
    }
  };

  Modal.prototype.clickHandler = function (event) {
    if (this.config.closeModalOnClick && !this.modal.contains(event.target)) {
      if (this.config.drawer) {
        this.closeDrawer();
      } else {
        this.closeModal();
      }
    }
  };

  return Modal;
}();